export const REDIRECT_NAME = 'Redirect';

export const PARENT_LAYOUT_NAME = 'ParentLayout';

export const PAGE_NOT_FOUND_NAME = 'PageNotFound';

export const EXCEPTION_COMPONENT = () => import('/@/views/sys/exception/Exception.vue');

/**
 * @description: default layout — 数据天河 shell (sidebar + topbar + router-view).
 * Replaces the upstream AntDV-based LayoutSider/LayoutHeader globally for all
 * LAYOUT-mounted routes. Pages mounted under mainOut bypass this entirely.
 */
export const LAYOUT = () => import('/@/layouts/annotate/index.vue');

/**
 * @description: legacy AntDV-based layout — kept for routes that still rely on
 * the old multi-tab header / mix sidebar / mobile drawer behavior. Prefer LAYOUT.
 */
export const LEGACY_LAYOUT = () => import('/@/layouts/default/index.vue');

/**
 * @description: parent-layout
 */
export const getParentLayout = (_name?: string) => {
  return () =>
    new Promise((resolve) => {
      resolve({
        name: PARENT_LAYOUT_NAME,
      });
    });
};
